<template>
  <main class="notification-images">
    <div class="data-description">
      <b>select mms notification image (recommended)</b>
    </div>
    <section>
      <div v-if="selectedNotificationImage" class="wrapper-notification selected-image">
        <img :src="selectedNotificationImage.attachment.thumb" title="notification image"/>
        <a @click="clickedRemove()" data-cy="notification-images-remove-button">remove</a>
      </div>
      <a v-else @click="showModal = true" class="wrapper-notification select-image-btn" data-cy="notification-images-select-image-button">
        <fai :icon="['fas', 'camera']" />
        select image
      </a>
      <notification-images-modal v-if="showModal"
        :custom-notification-images="customNotificationImages"
        :suggested-notification-images="suggestedNotificationImages"
        @hideModalAndRemoveSelectedNotificationImage="hideModalAndRemoveSelectedNotificationImage"
        @updateSelectedNotificationImage="$emit('updateSelectedNotificationImage', $event, isReferral)" />
    </section>
  </main>
</template>

<script>
  import NotificationImagesModal from "./notification-images-modal.vue";

  export default {
    props: {
      customNotificationImages: Array,
      selectedNotificationImage: Object,
      suggestedNotificationImages: Array,
      isReferral: {
        default: false,
        type: Boolean
      },
    },

    name: "NotificationImages",

    components: {
      NotificationImagesModal
    },

    data(){
      return {
        showModal: false,
      }
    },

    methods: {
      clickedRemove() {
        this.$emit('updateSelectedNotificationImage', null, this.isReferral)
      },
      hideModalAndRemoveSelectedNotificationImage(shouldRemove = true) {
        if(shouldRemove) this.$emit('updateSelectedNotificationImage', null, this.isReferral)
        this.showModal = false
      }
    }
  }
</script>

<style scoped>
  .loading-icon {
    margin: 0;
  }
  .notification-images {
    margin: 15px 0;
  }
  .data-description {
    margin-bottom: 10px;
  }
  .wrapper-notification {
    align-items: center;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    width: 106px;
  }
  .select-image-btn {
    background-color: #128ff9;
    border-radius: 16px;
    color: white;
    height: 92px;
  }
  .select-image-btn svg {
    display: block;
    fill: white;
    height: 45px;
    width: 55px;
  }
  .selected-image img{
    width: 100%;
    height: auto;
  }
</style>
